import React, { Component } from 'react';
import './App.css';
import {connect} from 'react-redux';
import { logout } from './actions';

class Nav extends Component {
  logout = () => {
    console.log("logging out");
    if(window.FB) window.FB.logout();
    this.props.dispatch(logout());
  }

  render() {
    let {info,user} = this.props;
    let menu = [];
    if(!user){
      menu.push({label:"Mi ez?",link:"#miez"});
    }else if(info){
      menu.push({label:"Kijelentkezés",onClick:this.logout,link:'#'});
    }else{
      menu.push({label:"Kijelentkezés",onClick:this.logout,link:'#'});
    }

    menu = menu.map((m,i) => <li className="nav-item" key={i}><a className="nav-link" href={m.link} onClick={m.onClick}>{m.label}</a></li>);    

    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
        <img src="/prevost-logo.png" alt="Prévost Hungária Kft."/>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
          <ul className="navbar-nav mr-auto">
            {menu}
          </ul>
        </div>
      </nav>
    );
  }
}

export default connect(
  state => ({user: state.user, info:state.userInfo}),
  dispatch => ({dispatch})
)(Nav);



// WEBPACK FOOTER //
// ./src/Nav.js